import { useState, useEffect } from 'react';
import Cookies1 from 'js-cookie';

export const useAuth = () => {
    const [authState, setAuthState] = useState({
        isAuthenticated: false,
        token: null,
        user: null
    });

    const updateAuthState = () => {
        const token = Cookies1.get('LoginToken');
        const userName = Cookies1.get('investorName');
        const userId = Cookies1.get('investorId');
        const userMail = Cookies1.get('investorMail');

        setAuthState({
            isAuthenticated: !!token,
            token: token,
            user: token ? {
                name: userName,
                id: userId,
                email: userMail
            } : null
        });
    };

    useEffect(() => {
        // Initial load
        updateAuthState();

        // Listen for authentication changes
        const handleAuthChange = () => {
            updateAuthState();
        };

        window.addEventListener('authStateChanged', handleAuthChange);

        return () => {
            window.removeEventListener('authStateChanged', handleAuthChange);
        };
    }, []);

    return authState;
}; 